'use client'

import React, { memo, ReactNode } from 'react'
import { useEffect, useRef, useState } from 'react'
import { motion, useScroll, useTransform } from 'framer-motion'
import { useMediaQuery } from '@/shared/utils'
import styles from './styles.module.scss'

export const CardsAnimation = memo(function CardsAnimation({ children }: { children: ReactNode }) {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const { scrollYProgress } = useScroll({ target: wrapperRef, offset: ['end end', 'end start'] })
  const opacity = useTransform(scrollYProgress, [0, 1], [0, 1])
  const transformY = useTransform(scrollYProgress, [0, 0.8], ['translateY(0px)', 'translateY(200px)'])

  const isSmall = useMediaQuery('screen and (max-width: 520px)')

  return isSmall ? (
    children
  ) : (
    <motion.div className={styles['prevInnerContent']} ref={wrapperRef} style={{ transform: transformY }}>
      {children}
      <motion.div className={styles['overlay']} style={{ opacity }} />
    </motion.div>
  )
})
